/**
 *
 * Asynchronously loads the component for TeamListPage
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
